(function () {

  'use strict';

  angular.module('eclipseApp.core').factory('brtSwitches', ['$http', '$q', function ($http, $q) {
    
    return {

      getBrtSwitches: function () {
        var self = this;
        var deferred = $q.defer();
        var brtSwitches = self['brtSwitches'];
        if (brtSwitches && brtSwitches.length > 0) {
          deferred.resolve(brtSwitches);
        } else {
          $http.post('/bfa-api/v1/brtSwitches')
            .then(function(response) {
              var switches = response.data;
              self['brtSwitches'] = switches;
              deferred.resolve(switches);
            });
        }
        return deferred.promise;
      }
    };
  }]);
})();